/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsactivechats2Inputs */

const en_statsactivechats2 = /** @type {(inputs: Statsactivechats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active chats`)
};

const de_statsactivechats2 = /** @type {(inputs: Statsactivechats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Chats`)
};

/**
* | output |
* | --- |
* | "Active chats" |
*
* @param {Statsactivechats2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsactivechats2 = /** @type {((inputs?: Statsactivechats2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsactivechats2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsactivechats2(inputs)
	return de_statsactivechats2(inputs)
});
export { statsactivechats2 as "statsActiveChats" }